import React from 'react';
import PropTypes from 'prop-types';
import InputFile from '../../../../../components/inputFile';
import AttachedFile from '../../../../../components/files/attachedFile';
import ValidationMessage from '../../../../../components/validation/ValidationMessage';
import './style.css';

const AddNew = ({
  t,
  errors,
  addItem,
  addedArt,
  mulTempFiles,
  postNewTicket,
}) => (
  <React.Fragment>
    <div className="addnewfedbck boxs">
      <div className="boxs addfdbckcmntD addfdbckticket">
        <div className="choseprty boxs">
          <div className="lefttD lefttD-additional">
            <div className="boxs add-new-ticket">
              <h6>{t('Choose priority')}:</h6>
              <ul className="ticDul">
                <li>
                  <a
                    href="#"
                    className={`${addedArt.priority === 1 ? 'active ' : ' '}choseprirtytab regularcol`}
                    onClick={(e) => { e.preventDefault(); addItem({ target: { name: 'priority', value: 1 } }); }}
                  >
                    {t('Regular')}
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className={`${addedArt.priority === 2 ? 'active ' : ' '}choseprirtytab moderatecol`}
                    onClick={(e) => { e.preventDefault(); addItem({ target: { name: 'priority', value: 2 } }); }}
                  >
                    {t('Moderate')}
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className={`${addedArt.priority === 3 ? 'active ' : ' '}choseprirtytab urgrntcol`}
                    onClick={(e) => { e.preventDefault(); addItem({ target: { name: 'priority', value: 3 } }); }}
                  >
                    {t('Urgent')}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="boxs cmntwfile">
          <div className="boxs fdbck">
            <textarea
              onChange={addItem}
              name="message"
              value={addedArt.message}
              className="form-control form-controlsearch"
              placeholder={t('Start typing')}
            />
            {/*<ValidationMessage*/}
              {/*message={errors.message && errors.message.message}*/}
              {/*valid={!errors.message}*/}
            {/*/>*/}
          </div>
          <div className="boxs fontmulisemi Attchfilefdbck">
            <div className="leftfbw">
              <div className="boxs">
                <span className="attchfilefbck ">{t('Attached files')}<span>({mulTempFiles.ticket ? mulTempFiles.ticket.length : 0})</span>:</span>
              </div>
            </div>
            <div>
              <InputFile
                id="ticket"
                groupFile
                label={t('Attach a file')}
                fields={prop => (
                  <AttachedFile file={prop.file} onRemove={prop.onRemove} upload/>
                )}
              />
            </div>
          </div>
          <div className="sndrqst boxs">
            <a href="#" className="sndrqstbtn sndsuprtbtn" onClick={e => postNewTicket(e)}>
              {t('Send to support team')}
            </a>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
);

AddNew.propTypes = {
  t: PropTypes.func.isRequired,
};

export default AddNew;



// WEBPACK FOOTER //
// ./src/views/modules/ticket/ticket/addNew/AddNew.jsx